export const ReconciliationStatus = {
    COMPUTING_DISCREPANCIES : "COMPUTING_DISCREPANCIES",
    COMPUTING_DISCREPANCIES_SUCCESS : "COMPUTING_DISCREPANCIES_SUCCESS",
    COMPUTING_DISCREPANCIES_FAILED : "COMPUTING_DISCREPANCIES_FAILED",
    RESOLVING_DISCREPANCIES : "RESOLVING_DISCREPANCIES",
    RESOLVING_DISCREPANCIES_SUCCESS : "RESOLVING_DISCREPANCIES_SUCCESS",
    RESOLVING_DISCREPANCIES_FAILED : "RESOLVING_DISCREPANCIES_FAILED",
    NO_DESCREPANCIES_FOUND : "NO_DESCREPANCIES_FOUND",
  };